import React, { Component } from 'react';
import { observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import CommunityBoardPage from 'pages/community/index';
import { privateRoute } from 'env/privateRoute';
import { withAppWrapper } from 'ui/components/withAppWrapper';


@withAppWrapper()
@privateRoute
@withCustomComponent('CommunityPrivatePage')
@observer
class CommunityPrivatePage extends Component {
  render() {
    return (
      <CommunityBoardPage
        componentName={this.props.componentName}
        privateThreads={true}
      />
    );
  }
}

export default CommunityPrivatePage;
